import type { BookingBridge } from "./contract";
import { createMockBridge } from "./mockBridge";
import { createHttpBridge } from "./httpBridge";

/**
 * Chooses the bridge implementation.
 *
 * Defaults to the mock. The HTTP bridge is selected only when `VITE_BOOKING_API_BASE` is set
 * *and* the flag is explicitly on, so nobody points a development build at a real hotel by
 * accident — and today it throws `BRIDGE_NOT_WIRED` anyway.
 */
export function resolveBridge(): BookingBridge {
  const apiBase = import.meta.env.VITE_BOOKING_API_BASE as string | undefined;
  const useHttp = (import.meta.env.VITE_BOOKING_BRIDGE as string | undefined) === "http";
  if (useHttp && apiBase) return createHttpBridge(apiBase);
  return createMockBridge({ latencyMs: import.meta.env.DEV ? 220 : 0 });
}

export * from "./contract";
